import React from "react";
import {FaPaw} from "react-icons/fa";
import {appStoreLink, isMobileDevice} from "../../js/helpers/functions";
import "./styles.css";

class OpenApp extends React.Component {
	constructor(props) {
		super(props);
		this.fallbackTimer = null;
		this.isMobile = isMobileDevice();
		this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
	}

	componentDidMount() {
		if (!this.isMobile) {
			window.location.replace("/");
			return;
		}

		const destination = this.props.match?.params?.destination || "discover";
		document.addEventListener("visibilitychange", this.handleVisibilityChange);

		// Universal Links/App Links normally open the installed app before this
		// page loads. The custom scheme covers clients that unwrap or redirect
		// email links; the store timer handles devices without Barkr installed.
		window.location.href = `barkr://open/${encodeURIComponent(destination)}`;
		this.fallbackTimer = window.setTimeout(() => appStoreLink(), 1200);
	}

	componentWillUnmount() {
		this.clearFallback();
		document.removeEventListener("visibilitychange", this.handleVisibilityChange);
	}

	handleVisibilityChange() {
		if (document.hidden) {
			this.clearFallback();
		}
	}

	clearFallback() {
		if (this.fallbackTimer) {
			window.clearTimeout(this.fallbackTimer);
			this.fallbackTimer = null;
		}
	}

	render() {
		if (!this.isMobile) {
			return null;
		}

		return (
			<main className="open-app">
				<div className="open-app__card">
					<span className="open-app__icon"><FaPaw/></span>
					<p className="open-app__eyebrow">OPENING BARKR</p>
					<h1>Taking you to the app…</h1>
					<p>If Barkr is not installed, we’ll take you to the right app store.</p>
					<button type="button" onClick={() => appStoreLink()}>Get Barkr</button>
				</div>
			</main>
		);
	}
}

export default OpenApp;
